import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { mastersSearchAPI } from 'src/api/MastersApi';

const MastersDropDown = ({
    value, name, masterType, disabled,
}) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Choose..."
        displayKeyPath={[
            'masterName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'masterName',
        ]}
        api={mastersSearchAPI}
        apiCallAddonData={{
            pageLength: '',
        }}
        value={value}
        whereConditions={{
            masterType: masterType,
            active: true,
        }}
        disabled={!masterType || disabled}
    />
);

MastersDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    masterType: PropTypes.string,
    disabled: PropTypes.bool,
};

MastersDropDown.defaultProps = {
    value: '',
    masterType: '',
    disabled: false,
};

export default MastersDropDown;
